















































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ReportingPeriodDto from '@/models/ReportingPeriods/ReportingPeriodDto';
import UpdateReportingPeriodRequest from '@/models/ReportingPeriods/UpdateReportingPeriodRequest';

@Component({ name: 'ReportingPeriodEdit' })
export default class extends GiganautVueDialog {
	@Prop({ required: true })
	period!: ReportingPeriodDto;

	entity = new UpdateReportingPeriodRequest();
	valid = false;
	showStartDatePicker = false;
	showEndDatePicker = false;
	hasLinkedTargets = false;

	@Watch('dialog')
	onDialogChanged(val: boolean) {
		if (val) {
			this.entity = new UpdateReportingPeriodRequest();
			this.entity.updatedAt = this.period.updatedAt as any;
			this.entity.fiscalYear = this.period.fiscalYear;
			this.entity.periodNumber = this.period.periodNumber;
			this.entity.label = this.period.label;
			this.entity.startDate = this.period.startDate ? this.period.startDate.substring(0, 10) : '';
			this.entity.endDate = this.period.endDate ? this.period.endDate.substring(0, 10) : '';
			// We don't know upfront if targets are linked; the backend will reject date changes if so
			this.hasLinkedTargets = false;
		}
	}

	async save() {
		if (!(this.$refs.form as any).validate()) return;
		await AgencySettingsModule.editReportingPeriod(this.entity);
		this.dialog = false;
		this.$emit('updated');
	}
}
